(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* ── Aurova product card: AJAX add-to-cart v4 ── */
(function () {
  /* Directly update the aurova badge element in the DOM */
  function updateBadge(count) {
    var badge = document.getElementById('aur-cart-badge');
    if (!badge) return;
    var n = parseInt(count, 10) || 0;
    badge.textContent = n > 99 ? '99+' : String(n);
    if (n > 0) {
      badge.classList.remove('aur-hdr__cart-badge--hidden');
    } else {
      badge.classList.add('aur-hdr__cart-badge--hidden');
    }
    /* Keep sessionStorage in sync for the theme's cart-icon.js */
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() }));
    } catch (_) {}
  }

  function addToCart(btn) {
    if (!btn || btn.disabled) return;
    var form = btn.closest ? btn.closest('form[data-aur-atc]') : btn.parentNode;
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;

    var origText = btn.textContent.trim();
    btn.textContent = '· · ·';
    btn.disabled = true;

    var fd = new FormData();
    fd.append('id', idInput.value);
    fd.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: fd
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status) {
        /* Shopify returned an error (sold out, invalid ID, etc.) */
        btn.textContent = data.description || data.message || 'Unavailable';
        setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2500);
        return;
      }
      btn.textContent = '✓ ADDED';
      /* Fetch live cart to get real item_count */
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateBadge(cart.item_count);
          /* Also fire the theme event so cart-drawer / cart-icon pick it up */
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, data: { itemCount: cart.item_count, didError: false } }
          }));
          setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 1800);
        })
        .catch(function () {
          setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 1800);
        });
    })
    .catch(function () {
      btn.textContent = origText;
      btn.disabled = false;
    });
  }

  /* Primary: click on the pill button — most reliable cross-browser */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.aur-pc__atc-btn');
    if (!btn) return;
    var form = btn.closest('form[data-aur-atc]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });

  /* Backup: keyboard Enter / form submit */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-aur-atc')) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(form.querySelector('.aur-pc__atc-btn'));
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
